import React, {useEffect, useState} from 'react';
import InputWithFloatingLabel from '../../common/floating-input-field/input-with-floating-label';
import * as SS from '../styles/shared-styles';
import * as S from './style';
import { MaxCharacterLimitInChildNameField } from '../../../constant-data/splashverse-onboarding';
import { Transition } from 'react-transition-group';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { useDispatch, useSelector } from 'react-redux'
import { setChildScreenName } from '../../../stores/splashverse-onboarding/actions';
import { TrackUserActionAnalytics } from '../../../services/loggedout-api';
import { gradesToSkipSubjectFor } from '../../../constant-data/splashverse-onboarding';
import { IsElaAvailabeForGrade } from '../helper/helper';
import { setItemInLocalStorage } from '../../../utils/web-helper';

const ChildName = ({isNextStep, goToNextHandler}) => {

  const [animate, setAnimate] = useState(false);
  const dispatch = useDispatch();

  const { selectedGrade, gradeCodeMap, skipSubject, subjectGradeMap, skipPOQ, selectedSubject } = useSelector(state => {
    return {
      selectedGrade: state.selectedGrade,
      gradeCodeMap: state.gradeCodeMap,
      skipSubject: state.skipSubject,
      subjectGradeMap: state.subjectGradeMap,
      selectedSubject: state.selectedSubject,
      skipPOQ: state.skipPOQ,
    }
  });

  const { setValue } = useExtendedLocalStorage('splashverse-onboarding', '');

  useEffect(() => {
    setTimeout(() => {
      setAnimate(true);
    }, 100)
    trackAnalyticsEvent('Child Name Screen Viewed',{}, true);
  }, []);

  const submitHandler = (name) => {
    trackAnalyticsEvent('Child Name Screen Interacted',{}, true);
    try {
      TrackUserActionAnalytics({
      user_action: 'screen_name_entered',
    }, true)} catch (e) {
      console.log(e);
    }
    setItemInLocalStorage('tutoringChildName', name);
    setValue('childName', name);
    dispatch(setChildScreenName(name));
    goToNextStep();
  }

  const goToNextStep = () => {
    let opt = {};
    if (selectedGrade) {
      const gradeId = gradeCodeMap.get(selectedGrade).id;
      // abtest - POQFirstSubject only for pre-k and k
      let skipSubjectForPrekAndK = skipSubject && gradesToSkipSubjectFor.indexOf(selectedGrade) != -1;
      let isElaAvailabeForGrade = IsElaAvailabeForGrade(gradeId, subjectGradeMap)
      opt = {
        isPreKindergarten: selectedGrade === 'pk',
        skipSubjectForPrekAndK, isElaAvailabeForGrade, skipPOQ
      }
    }
    if (selectedSubject) {
      opt = {...opt, selectedSubject}
    }
    goToNextHandler('child_screen_name', opt);
  }

  return (
    <Transition in={animate} timeout={500}>
      {(state) => (
        <SS.OnboardingStepWrapper state={state} isNextStep={isNextStep}>
          <SS.StepHeader>
            Enter your child's nickname
          </SS.StepHeader>
          <SS.StepSubheader >
            This will be their screen name on SplashLearn
          </SS.StepSubheader>
          <S.ChildNameContainer >
            <InputWithFloatingLabel labelText={'Screen name'} placeholderText={'Choose a short screen name '} helperMessage={'Maximum 12 characters'} maxLength={MaxCharacterLimitInChildNameField} submitHandler={submitHandler} shouldFocus={true}/>
          </S.ChildNameContainer>
        </SS.OnboardingStepWrapper>
      )}
    </Transition>
  )
}

export default ChildName;